document.addEventListener("DOMContentLoaded", () => {
  let currentVariantId = null;

  function formatMoney(cents) {
    return `$${(Number(cents) / 100).toFixed(2)}`;
  }

  function getLoopProduct() {
    if (!window.LOOP_WIDGET) return null;

    const productId = Object.keys(window.LOOP_WIDGET)[0];
    if (!productId) return null;

    return window.LOOP_WIDGET[productId]?.product || null;
  }

  function getCurrentVariantId() {
    const variantSelect = document.querySelector('select[name="id"]');
    return variantSelect ? String(variantSelect.value) : null;
  }

  function getCurrentVariant() {
    const product = getLoopProduct();
    const variantId = getCurrentVariantId();

    if (!product || !variantId) return null;

    return product.variants.find((variant) => {
      return String(variant.id) === String(variantId);
    });
  }

  function getSellingPlanInput() {
    const form = document.querySelector("#AddToCartForm");
    if (!form) return null;

    let input = form.querySelector('input[name="selling_plan"]');

    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = "selling_plan";
      form.appendChild(input);
    }

    return input;
  }

  function isSubscriptionSelected() {
    const subscriptionOption = document.querySelector(
      "[data-loop-widget-selling-plan-group]"
    );

    const oneTimeOption = document.querySelector(
      "[data-loop-widget-onetime-purchase-option]"
    );

    if (subscriptionOption?.classList.contains("loop-widget-purchase-option-selected")) {
      return true;
    }

    if (oneTimeOption?.classList.contains("loop-widget-purchase-option-selected")) {
      return false;
    }

    // Default to subscription if a frequency is selected
    return !!document.querySelector(".loop-widget-sp-button-selected[data-selling-plan-id]");
  }

  function getSelectedSellingPlanId() {
    const selectedPlanButton = document.querySelector(
      ".loop-widget-sp-button-selected[data-selling-plan-id]"
    );

    if (selectedPlanButton) {
      return String(selectedPlanButton.dataset.sellingPlanId);
    }

    const variant = getCurrentVariant();

    return variant?.selling_plan_allocations?.[0]?.selling_plan_id
      ? String(variant.selling_plan_allocations[0].selling_plan_id)
      : "";
  }

  function getSelectedAllocation(variant) {
    if (!variant || !variant.selling_plan_allocations?.length) return null;

    const sellingPlanId = getSelectedSellingPlanId();

    return (
      variant.selling_plan_allocations.find((allocation) => {
        return String(allocation.selling_plan_id) === String(sellingPlanId);
      }) || variant.selling_plan_allocations[0]
    );
  }

  function syncSellingPlanInput() {
    const input = getSellingPlanInput();
    if (!input) return;

    if (!isSubscriptionSelected()) {
      input.value = "";
      input.disabled = true;
      console.log("Selling plan cleared: one-time purchase selected");
      return;
    }

    const variant = getCurrentVariant();
    const allocation = getSelectedAllocation(variant);

    if (!allocation) return;

    input.disabled = false;
    input.value = String(allocation.selling_plan_id);

    input.dispatchEvent(new Event("change", { bubbles: true }));

    console.log("Selling plan synced:", input.value);
  }

  function updateLoopWidgetPrices() {
    const variant = getCurrentVariant();

    if (!variant) return;

    const allocation = getSelectedAllocation(variant);

    const subscriptionOption = document.querySelector(
      "[data-loop-widget-selling-plan-group]"
    );

    const oneTimeOption = document.querySelector(
      "[data-loop-widget-onetime-purchase-option]"
    );

    if (subscriptionOption && allocation) {
      const subscriptionComparePrice = subscriptionOption.querySelector(
        ".loop-widget-purchase-option-compare-at-price"
      );

      const subscriptionPrice = subscriptionOption.querySelector(
        ".loop-widget-purchase-option-price"
      );

      if (subscriptionComparePrice) {
        subscriptionComparePrice.textContent = formatMoney(
          allocation.compare_at_price || variant.price
        );
      }

      if (subscriptionPrice) {
        subscriptionPrice.textContent = formatMoney(allocation.price);
      }
    }

    if (oneTimeOption) {
      const oneTimeComparePrice = oneTimeOption.querySelector(
        ".loop-widget-purchase-option-compare-at-price"
      );

      const oneTimePrice = oneTimeOption.querySelector(
        ".loop-widget-purchase-option-price"
      );

      if (oneTimeComparePrice) {
        oneTimeComparePrice.textContent = "$0.00";
      }

      if (oneTimePrice) {
        oneTimePrice.textContent = formatMoney(variant.price);
      }
    }

    syncSellingPlanInput();

    console.log("Loop prices synced for variant:", variant.id);
  }

  function watchVariantChanges() {
    const newVariantId = getCurrentVariantId();

    if (!newVariantId) return;

    if (newVariantId !== currentVariantId) {
      currentVariantId = newVariantId;
      setTimeout(updateLoopWidgetPrices, 100);
    }
  }

  setInterval(watchVariantChanges, 250);

  document.body.addEventListener("click", (event) => {
    if (
      event.target.closest(".loop-widget-sp-button") ||
      event.target.closest(".loop-widget-purchase-option")
    ) {
      setTimeout(updateLoopWidgetPrices, 150);
    }
  });

  const form = document.querySelector("#AddToCartForm");

  if (form) {
    form.addEventListener(
      "submit",
      () => {
        syncSellingPlanInput();
      },
      true
    );
  }

  setTimeout(updateLoopWidgetPrices, 800);
});